import React, { useMemo } from "react";

type ProductPreference = {
    rank: number;
    name: string;
    count: number;
};

export default function ProductPreferencesCard({
                                                   productPreferences,
                                               }: {
    productPreferences: ProductPreference[];
}) {
    const top = useMemo(() => (productPreferences || []).slice(0, 10), [productPreferences]);

    if (!top.length) {
        return (
            <div className="rounded-lg border bg-muted/20 p-4 text-sm text-muted-foreground">
                Нет данных за выбранный период
            </div>
        );
    }

    return (
        <div className="grid gap-2 sm:grid-cols-2">
            {top.map((p) => (
                <div
                    key={`${p.rank}-${p.name}`}
                    className="flex items-center justify-between rounded-lg border p-3"
                >
                    <div className="flex items-center gap-3 min-w-0">
                        <div className="rounded-md bg-muted px-2 py-1 text-xs font-semibold">
                            TOP.{p.rank}
                        </div>
                        <div className="truncate text-sm font-medium">{p.name}</div>
                    </div>
                    <div className="text-sm text-muted-foreground">({p.count})</div>
                </div>
            ))}
        </div>
    );
}
